import { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col, Form, Button, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./users.scss";
import { withRouter } from "react-router";
import { DataService } from "../../shared/services/data.service";
import { NotifierService } from "../../shared/services/notifier.service";
import { SpinnerService } from "../../shared/services/spinner.service";
import {
  faArrowCircleLeft,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AuthenticateService } from "../../security/login/authenticate.service";

interface addUserState {
  startDate?: any;
  mode?: any;
  user?: any;
  profiles?: any;
  tenants?: any;
  error?: any;
  errors?: any[];
  message?: any;
}
class AddUserComponent extends Component<any, addUserState> {
  constructor(props: any) {
    super(props);
    this.state = {
      startDate: new Date(),
      mode: "N",
      user: {},
      profiles: [],
      tenants: [],
      error: {},
    };
  }

  async convertToObject(error: any) {
    let list: any = [];
    const messageSplitter = error.err.split(". ");
    if (messageSplitter.length > 1 && messageSplitter[1]) {
      list = messageSplitter[1].slice(1, -1).split(",");
    }
    let errors: any = [];
    list.forEach((message: any) => {
      errors.push({ messageText: message });
    });
    this.setState({ errors });
  }

  async submitHandler(event: any) {
    try {
      SpinnerService.show();
      event.preventDefault();
      this.setState({ errors: [] });
      const user = this.state.user || {};
      const error = this.state.error || {};
      if (Object.keys(error).length) {
        SpinnerService.hide();
        return false;
      }
      const isUpdate = this.state.mode !== "N";
      const permission = {
        type: "T",
        referenceId: `${user.tenantId}`,
        access: "A",
      };

      if (isUpdate) {
        const data: any = {
          name: user.name,
          email: user.email,
          profileId: user.profileId,
          contactNo: user.contactNo,
          permissions: [permission],
        };
        if (user.password && user.password.length > 0) {
          data.password = user.password;
        }
        await DataService.put(`users/${user.userId}`, data, {});
        NotifierService.success("User Updated Successfully.");
      } else {
        const data = {
          password: user.password,
          sendActivationMail: true,
          email: user.email,
          accountExpiry: undefined,
          profileId: user.profileId,
          name: user.name,
          type: user.type,
          agreementAccepted: true,
          createdByUserId: 1,
          contactNo: user.contactNo,
          permissions: [permission],
        };

        const postuser: any = await DataService.post("users/signup", data, {});
        if (postuser.status === "error") {
          this.convertToObject(postuser);
        } else {
          NotifierService.success("User Registered Successfully.");
        }
      }
      SpinnerService.hide();
    } catch (error) {
      SpinnerService.hide();
      if (error.status === 400 && error.data && error.data.length > 0) {
        if (Array.isArray(error.data)) {
          return this.setState({ errors: error.data });
        }
        this.setState({ errors: [{ messageText: error.data }] });
        return;
      }
      NotifierService.error(
        "Unable to save. Please connect with administrator.",
      );
    }
  }

  async componentDidMount() {
    try {
      SpinnerService.show();
      const profiles = await AuthenticateService.getProfiles();
      const tenants = await AuthenticateService.getTenants();
      this.setState({ profiles, tenants });

      const userId = this.props.match.params.userId;
      if (userId && !isNaN(userId)) {
        const users = await DataService.get(`users/${userId}`, {});
        const user = Array.isArray(users) && users.length > 0 ? users[0] : {};

        if (!user || !user.userId) {
          NotifierService.error("Unable to find user");
        }

        const permissions = user.permissions || [];
        const permission =
          permissions && permissions.length > 0 ? permissions[0] : {};
        user.tenantId = parseInt(permission.referenceId);
        user.password = "";

        this.setState({ user, mode: user && user.userId ? "U" : "N" });
      }
      SpinnerService.hide();
    } catch (error) {
      NotifierService.error("Internal Server Error.");
    }
  }

  updateUser = (event: any) => {
    const user = this.state.user || {};
    user[event.target.id] = event.target.value;
    this.checkValidation(user);
    this.setState({ user });
  };

  async checkValidation(user: any) {
    const nameRegex: any = /^[A-Za-z0-9' ]+$/;
    const emailRegex: any = /^[a-zA-Z0-9\-_.]+@[a-zA-Z0-9]+\.[A-Za-z]+$/;
    const contactRegex: any = /^\+?\d{1,3}(-|)?\d{3,5}(-|)?\d{1,10}$/;
    const error: any = {};
    if (user && user.name && !nameRegex.test(user.name)) {
      error["name"] = true;
    }
    if (user && user.email && !emailRegex.test(user.email)) {
      error["email"] = true;
    }
    if (user && user.contactNo && !contactRegex.test(user.contactNo)) {
      error["contactNo"] = true;
    }
    this.setState({ error });
  }

  render() {
    const profiles = this.state.profiles || [];
    const tenants = this.state.tenants || [];
    const user = this.state.user || {};
    const mode = this.state.mode;
    const isUpdate = mode !== "N";
    const error = this.state.error;
    var errors = this.state.errors || [];

    return (
      <div className="report-container">
        <Row>
          <Col xs={12} className="users-title light-background">
            <Link to="/administration">
              <FontAwesomeIcon
                icon={faArrowCircleLeft}
                size="1x"
                color="white"
                title="Back to user list"
              />
            </Link>
            &nbsp;
            {isUpdate ? `User - ${user.email}` : "Register New User"}
          </Col>
        </Row>
        <Container fluid={true} className="add-user-container">
          <Row className="ml-4">
            <Col xs={12} className="panel-body">
              <Row>
                <Col xs={12} md={9} sm={9}>
                  <Form
                    autoComplete="new-password"
                    onSubmit={async (event) => {
                      await this.submitHandler(event);
                    }}
                  >
                    <Table responsive bordered>
                      <tbody>
                        <tr>
                          <td className="td">
                            <Form.Label column>
                              Name:{" "}
                              <FontAwesomeIcon
                                icon={faInfoCircle}
                                size="xs"
                                color="white"
                                title="Name Should not contain Special Character"
                              />
                            </Form.Label>
                          </td>
                          <td>
                            <Col>
                              <Form.Control
                                type="text"
                                className={error && error.name ? "error" : ""}
                                name="name"
                                placeholder="Name"
                                id="name"
                                onChange={this.updateUser}
                                value={user.name}
                                required
                              />
                            </Col>
                          </td>
                        </tr>
                        <tr>
                          <td className="td">
                            <Form.Label column>Email:</Form.Label>
                          </td>
                          <td>
                            <Col>
                              <Form.Control
                                type="email"
                                name="email"
                                className={error && error.email ? "error" : ""}
                                placeholder="email e.g. john.smith@acme.com"
                                id="email"
                                onChange={this.updateUser}
                                value={user.email}
                                required
                              />
                            </Col>
                          </td>
                        </tr>
                        <tr>
                          <td className="td">
                            <Form.Label column>Mobile Number:</Form.Label>
                          </td>
                          <td>
                            <Col>
                              <Form.Control
                                type="text"
                                name="contactNo"
                                className={
                                  error && error.contactNo ? "error" : ""
                                }
                                placeholder="Mobile Number"
                                id="contactNo"
                                onChange={this.updateUser}
                                value={user.contactNo}
                              />
                            </Col>
                          </td>
                        </tr>
                        <tr>
                          <td className="td">
                            <Form.Label column>Password:</Form.Label>
                          </td>
                          <td>
                            <Col>
                              <Form.Control
                                type="password"
                                name="password"
                                className={
                                  error && error.password ? "error" : ""
                                }
                                placeholder="*********"
                                id="password"
                                onChange={this.updateUser}
                                value={user.password}
                              />
                            </Col>
                          </td>
                        </tr>
                        <tr>
                          <td className="td">
                            <Form.Label column>Role:</Form.Label>
                          </td>
                          <td>
                            <Col>
                              <Form.Control
                                as="select"
                                id="profileId"
                                name="profileId"
                                value={user.profileId}
                                onChange={this.updateUser}
                                required
                              >
                                <option value="-1">
                                  Please select Profile
                                </option>
                                {profiles.map((profile: any, i: any) => (
                                  <option
                                    key={`profile-${profile.profileId}`}
                                    value={profile.profileId}
                                  >
                                    {profile.profileName}
                                  </option>
                                ))}
                              </Form.Control>
                            </Col>
                          </td>
                        </tr>
                        <tr>
                          <td className="td">
                            <Form.Label column sm="2">
                              Bank:
                            </Form.Label>
                          </td>
                          <td>
                            <Col>
                              <Form.Control
                                as="select"
                                name="tenantId"
                                id="tenantId"
                                value={"" + user.tenantId}
                                onChange={this.updateUser}
                                required
                              >
                                <option value="">Please select Bank</option>
                                {tenants.map((tenant: any, i: any) => (
                                  <option
                                    key={`tenant-${tenant.tenantId}`}
                                    value={tenant.tenantId}
                                  >
                                    {tenant.tenantName}
                                  </option>
                                ))}
                              </Form.Control>
                            </Col>
                          </td>
                        </tr>
                        <tr
                          className="error-container"
                          style={{
                            display: errors && errors.length > 0 ? "" : "none",
                          }}
                        >
                          <td colSpan={2}>
                            <ul>
                              {errors.map((error, index) => {
                                return (
                                  <li key={`error-${index}`}>
                                    {" "}
                                    {error.messageText}{" "}
                                  </li>
                                );
                              })}
                            </ul>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Button className="mr-2" type="submit">
                              {isUpdate ? "Update" : "Register"}
                            </Button>
                          </td>
                          <td align="right">
                            <Button className="mr-2" type="Reset">
                              Reset
                            </Button>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Form>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  static properties = (state: any) => {
    return {};
  };

  static dispatchers = (dispatch: any) => {
    return {};
  };
}

export const AddUser = connect(
  AddUserComponent.properties,
  AddUserComponent.dispatchers,
)(withRouter(AddUserComponent));
